import { Link, useLocation } from "react-router-dom";
import { ReactNode, useCallback } from "react";
import styles from "./AuthLayout.module.css";
import andyHdLogo from "@/assets/andyhdlogo.png";
import { routes } from "../navigation/routes";

interface AuthLayoutProps {
  children: ReactNode;
}

/**
 * AuthLayout Component
 * Shared layout for authentication pages (Login, Signup)
 * Includes logo, form wrapper, and footer
 */
export const AuthLayout = ({ children }: AuthLayoutProps) => {
  const location = useLocation();
  const currentYear = useCallback(() => {
    return new Date().getFullYear();
  }, []);

  if (
    location.pathname === routes.login ||
    location.pathname === routes.signup ||
    location.pathname === routes.forgotPassword
  ) {
    return <>{children}</>;
  }

  return (
    <div className={styles.authContainer}>
      {/* Logo */}
      <div className={styles.logoContainer}>
        <img src={andyHdLogo} alt="Andy logo" className={styles.logoImage} />
        <span className={styles.logoText}>ANDY</span>
      </div>

      {/* Form Wrapper */}
      <div className={styles.formWrapper}>{children}</div>

      {/* Footer */}
      <div className={styles.footer}>
        <span>Copyright©{currentYear()}</span>
        <Link to="#" className={styles.footerLink}>
          Privacy Policy
        </Link>
      </div>
    </div>
  );
};
